/**
 * @generated SignedSource<<44de951247a9bed099ff3401bd5d9b82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VerifyAuthProviderInput = {
  token: string;
};
export type useCompleteSSORedirectVerifyMutation$variables = {
  input: VerifyAuthProviderInput;
};
export type useCompleteSSORedirectVerifyMutation$data = {
  readonly verifyAuthProvider: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type useCompleteSSORedirectVerifyMutation = {
  response: useCompleteSSORedirectVerifyMutation$data;
  variables: useCompleteSSORedirectVerifyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyAuthProviderResponse",
    "kind": "LinkedField",
    "name": "verifyAuthProvider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCompleteSSORedirectVerifyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCompleteSSORedirectVerifyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8dd0bcae6a69b060ad42303587cd5db0",
    "id": null,
    "metadata": {},
    "name": "useCompleteSSORedirectVerifyMutation",
    "operationKind": "mutation",
    "text": "mutation useCompleteSSORedirectVerifyMutation(\n  $input: VerifyAuthProviderInput!\n) {\n  verifyAuthProvider(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd434238abf1ce8368ea440509c12106";

export default node;
